import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "twitter.icon",
  "use": "twitter.icon-usage",
  "viewBox": "1620.171 -11147.801 11.658 9.473",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"1620.171 -11147.801 11.658 9.473\" id=\"twitter.icon\"><path d=\"M29.326,21.21a3.888,3.888,0,0,1-1.5.532h0a2.4,2.4,0,0,0-4.083,2.2h0a6.661,6.661,0,0,1-4.958-2.5,2.406,2.406,0,0,0,.729,3.178,1.546,1.546,0,0,1-1.05-.272A2.318,2.318,0,0,0,20.32,26.7a1.9,1.9,0,0,1-1,.076,2.274,2.274,0,0,0,2.15,1.632,4.277,4.277,0,0,1-3.468,1,7.226,7.226,0,0,0,3.762,1.063,6.682,6.682,0,0,0,6.731-7.024s0-.009,0-.013,0-.02,0-.03,0-.023,0-.035a4.149,4.149,0,0,0,1.166-1.231,4.215,4.215,0,0,1-1.334.378,2.555,2.555,0,0,0,1-1.306\" transform=\"translate(1602.171 -11168.8)\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/twitter.icon.svg
// module id = /R7B
// module chunks = 13